import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  id: '',
  name: '',
  careersPageName: '',
  standalone: {},
  jobs: [],
  selectedJob: null,
}

export const companySlice = createSlice({
  name: 'company',
  initialState,
  reducers: {
    companyFetched: (state, action) => ({ ...state, ...action.payload }),
    jobsFetched: (state, action) => ({ ...state, ...action.payload }),
    jobSelected: (state, action) => ({ ...state, selectedJob: action.payload }),
  },
})

// Action creators are generated for each case reducer function
export const { companyFetched, jobSelected, jobsFetched } = companySlice.actions
export default companySlice.reducer
